import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Glossary from './icon-glossary.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Glossary {...validProps} />;
}

SvgComponent.iconName = 'glossary';

export const GlossaryIcon = svgIconWrapper(SvgComponent);
